import React from "react"

// TODO: Turn it on inside config-data.js file
const Special = () => {

	return(
    <></>
  );
};

export default Special